module.exports = __webpack_public_path__ + "media/assets/images/payments/puntopagos-b60b274f166c997c492e3d98b6b40356.png";